import React, { useState } from 'react'
import CertComponets from './CertComponents/CertComponets'

import './Certifications.css'

const Certifications = () => {
  return (
    <div className='parentMaxWidth' id='Work-History'>
    <div className='qualificationsOverview '>
       <h2 className='SectHeader'>
       <span className="reveal-word">More</span>
      <span className="reveal-word">About</span>
      <span className="reveal-word">Me</span>
      </h2>
    <CertComponets></CertComponets>
     </div>
     </div>

    
  )
}

export default Certifications